import React from 'react'
import IcomoonReact from 'icomoon-react'
import classNames from 'classnames'
import { useGlobalContext } from 'src/stores/GlobalContext'
import { pluralizeString } from 'src/utils/helpers/GeneralHelpers'
import rebrandIconList from 'src/assets/icons/rebrandIconList.json'
import variables from 'src/assets/styles/variables.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import fabStyles from './fabStyles.module.scss'

const FAB = ({ fab }) => {
  const { setSidePanelDetails } = useGlobalContext()

  const handleClick = () => {
    setSidePanelDetails({ type: 'fab', data: null, title: 'Action Items' })
  }

  return (
    <button onClick={() => handleClick()} className={fabStyles.fabContainer}>
      <div className={fabStyles.fabContents}>
        <IcomoonReact
          iconSet={rebrandIconList}
          color={variables.white}
          size={24}
          icon="Alert"
          className={fabStyles.icon}
        />
        <div className={fabStyles.textContainer}>
          <span className={fontStyles.psmallboldlsin01whitegraphik15pt}>
            Its time to catch up on your{' '}
            <span
              className={classNames(
                fontStyles.psmallboldlsin01whitegraphik15pt
              )}
            >
              {fab.length} {pluralizeString('Action Item', fab)}
            </span>
          </span>
        </div>
      </div>
    </button>
  )
}

export default FAB
